<template>
    <SectionBase v-bind="$attrs"  :section="section">
        <div :class="['ufo--columns', 'ufo--columns-' + section.statItems.length]">
            <div v-for="(data, index) in section.statItems" class="ufo--column" :style="{'--numberFontSize': getFontSize(data.data, 80), '--textFontSize': getFontSize(data.description, 30)}">
                <div class="ufo--column-content">
                    <AnimationWrapper :delay-animation="index ? index * 0.1 : 0">
                        <template #animationContent>
                            <div :class="['number', data.data.style && data.data.style.textStyle ? data.data.style.textStyle : 'default']"
                                :style="{'--numberSizeBase': numberSize(data)}"
                                v-html="fixText(data.data.text)"
                            >
                            </div>
                        </template>
                    </AnimationWrapper>
                    <AnimationWrapper :delay-animation="index ? index * 0.1 : 0">
                        <template #animationContent>
                            <div :class="['unit', data.description.style && data.description.style.textStyle ? data.description.style.textStyle : 'default']"
                                 :style="{'--unitSizeBase': unitSize(data) }"
                                 v-html="fixText(data.description.text)"
                            >
                            </div>
                        </template>
                    </AnimationWrapper>
                </div>
            </div>
        </div>
    </SectionBase>
</template>

<script>
import SectionBase from "./SectionBase.vue";
import AnimationWrapper from "../../../common/components/AnimationWrapper.vue";

export default {
    name: "Stats",
    components: {SectionBase, AnimationWrapper},
    props: ['section'],
    methods: {
        fixText(data) {
            return data.replaceAll('\n', '<br/>')
        },
        getFontSize(item, def) {
            return `${item.style && item.style.fontSize ? item.style.fontSize : def}px`
        },
        numberSize(item) {
            return item.data.style && item.data.style.fontSize ? item.data.style.fontSize + 'px' : null
        },
        unitSize(item) {
            return item.description.style && item.description.style.fontSize ? item.description.style.fontSize + 'px' : null
        }
    }
}
</script>

<style lang="scss" scoped>
    .ufo-sec {
        .number {
            --numberSize: var(--numberSizeBase);
            * {
                font-size: var(--numberSize);
            }
        }
        @media (max-width: 768px) {
            .number {
                --numberSize: calc(var(--numberSizeBase) * 0.8125); // 80 → 65
            }
        }

        @media (max-width: 640px) {
            .number {
                --numberSize: calc(var(--numberSizeBase) * 0.625); // 80 → 50
            }
        }

        .unit {
            * {
                font-size: var(--unitSize);
            }
        }
        @media (max-width: 640px) {
            .unit {
                --unitSize: calc(var(--unitSizeBase) * 0.8125);
            }
        }

        @media (max-width: 480px) {
            .unit {
                --unitSize: calc(var(--unitSizeBase) * 0.625);
            }
        }
    }
</style>
